import ICWarning from 'assets/icons/warning-icon.svg'
import CustomButton from 'components/Buttons/CustomButton'
import { useState } from 'react'
import { AlertCircle } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { Modal, ModalBody } from 'reactstrap'
import { useLazyFetchFarmersDetailQuery } from '../farmers-list/farmersListApiSlice'
import { useDeleteMultimediaMutation } from './detailFarmersApiSlice'
import { toggleModalDeleteFile } from './detailSlice'

const ModalDeleteFile = ({ selectedFile, row, setIsFinishRemove }) => {
  const dispatch = useDispatch()
  const [errMsg, setErrMsg] = useState('')
  const { isOpenModalDeleteFile } = useSelector((s) => s.farmersDetail)
  const [fetchDetailFarmers] = useLazyFetchFarmersDetailQuery()
  const [deleteFile, { isLoading: laodingEdit }] = useDeleteMultimediaMutation()

  const handleConfirmDelete = async () => {
    try {
      const res = await deleteFile({ id: selectedFile?.id }).unwrap()
      if (res) {
        dispatch(toggleModalDeleteFile())
        fetchDetailFarmers({ id: row?.userId })
        setIsFinishRemove(true)
      }
    } catch (error) {
      setErrMsg(error?.data?.message)
    }
  }

  return (
    <Modal
      centered
      toggle={() => dispatch(toggleModalDeleteFile())}
      isOpen={isOpenModalDeleteFile}
      data-testid="farmer-delete-file-modal"
    >
      <ModalBody>
        <img src={ICWarning} alt="Warning Icon" />
        <h6 className="mt-4 fw-600">Hapus file ini?</h6>
        <small>File yang sudah dihapus tidak dapat dikembalikan.</small>
        {errMsg && (
          <div>
            <small className="text-danger">
              <AlertCircle size={15} /> {errMsg}
            </small>
          </div>
        )}
        <div className="d-flex gap-3 mt-4">
          <CustomButton
            onClick={() => dispatch(toggleModalDeleteFile())}
            block
            outline
            color="secondary"
            testId="farmer-delete-file-cancel-button"
          >
            Batal
          </CustomButton>
          <CustomButton
            onClick={handleConfirmDelete}
            block
            color="danger"
            testId="farmer-delete-file-submit-button"
          >
            Hapus
          </CustomButton>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ModalDeleteFile
